import type { BrandName } from '@/scopes/common/domain/types'

export function shouldShowPetTransferInfo(brandName: BrandName): boolean {
  return brandName !== 'eliza'
}
